(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["riza-account-login-js"] && !Shopify.designMode) return;
  try {
    (function () {
    const auth = document.querySelector('[data-account-auth]');
    if (!auth) return;

    function show(view) {
      auth.querySelectorAll('[data-view]').forEach((el) => {
        el.hidden = el.dataset.view !== view;
      });
    }

    auth.querySelectorAll('[data-show]').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const view = link.dataset.show;
        show(view);
        history.replaceState(null, '', view === 'recover' ? '#recover' : ' ');
      });
    });

    if (window.location.hash === '#recover' || auth.querySelector('[data-recover-active]')) {
      show('recover');
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["riza-kit-card"] && !Shopify.designMode) return;
  try {
    (function () {
    // Handler próprio do card do kit (classes exclusivas para não colidir com
    // o stepper do riza-pcard, que também é delegado no documento).
    var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    document.addEventListener('click', function (e) {
      // Stepper +/-
      var step = e.target.closest('.riza-kitcard__qty-btn');
      if (step) {
        var input = step.parentElement.querySelector('.riza-kitcard__qty-input');
        if (!input) return;
        var val = (parseInt(input.value, 10) || 1) + parseInt(step.dataset.step, 10);
        if (val < 1) val = 1;
        input.value = val;
        return;
      }

      // Comprar o kit → adiciona os componentes reais e vai para /cart
      var btn = e.target.closest('.riza-kitcard__btn');
      if (!btn || btn.classList.contains('riza-kitcard__btn--soldout') || btn.disabled) return;
      e.preventDefault();

      var ids = (btn.dataset.components || '')
        .split(',')
        .map(function (s) { return parseInt(s.trim(), 10); })
        .filter(function (n) { return n > 0; });
      if (!ids.length) return;

      var bottom = btn.closest('.riza-kitcard__buy-bottom');
      var qtyInput = bottom ? bottom.querySelector('.riza-kitcard__qty-input') : null;
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      // Adiciona os componentes como linhas normais (sem property) — no carrinho
      // eles são agrupados num bloco de kit por detecção dos componentes, então
      // um add pelo botão do kit e um add avulso do mesmo produto se fundem.
      var items = ids.map(function (id) { return { id: id, quantity: qty }; });

      if (!btn.dataset.label) btn.dataset.label = btn.textContent.trim();
      btn.disabled = true;
      btn.textContent = 'Adicionando…';

      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (res.ok) { window.location.href = rootUrl + 'cart'; return; }
          btn.disabled = false;
          btn.textContent = 'Estoque insuficiente';
          setTimeout(function () { btn.textContent = btn.dataset.label; }, 2500);
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = btn.dataset.label;
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["riza-pcard"] && !Shopify.designMode) return;
  try {
    (function () {
    // Delegado no documento — cobre todos os cards da página (home/coleção).
    const root_url = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    // Máximo efetivo: estoque restante (data-remaining, já descontando o
    // que está no carrinho) se conhecido; senão o estoque bruto (data-max).
    function maxFor(input) {
      if (input.dataset.remaining !== undefined) return parseInt(input.dataset.remaining, 10);
      if (input.dataset.max) return parseInt(input.dataset.max, 10);
      return null;
    }

    // Mantém a quantidade entre 1 e o máximo, desabilita botões nos limites
    // e bloqueia o "Comprar" quando não há estoque restante.
    function clamp(input) {
      const min = parseInt(input.min, 10) || 1;
      const max = maxFor(input);
      const wrap = input.parentElement;
      const minus = wrap.querySelector('.riza-qty__btn[data-step="-1"]');
      const plus = wrap.querySelector('.riza-qty__btn[data-step="1"]');
      const form = input.closest('.riza-pcard__form');
      const submit = form ? form.querySelector('.riza-pcard__btn') : null;

      // Sem estoque restante (já no máximo dentro do carrinho)
      if (max !== null && max <= 0) {
        input.value = 0;
        if (minus) minus.disabled = true;
        if (plus) plus.disabled = true;
        if (submit) {
          submit.disabled = true;
          if (!submit.dataset.label) submit.dataset.label = submit.textContent.trim();
          submit.textContent = 'Sem estoque disponível';
        }
        return;
      }

      let val = parseInt(input.value, 10) || min;
      if (max !== null && val > max) val = max;
      if (val < min) val = min;
      input.value = val;

      if (minus) minus.disabled = val <= min;
      if (plus) plus.disabled = max !== null && val >= max;
      if (submit) {
        submit.disabled = false;
        if (submit.dataset.label) submit.textContent = submit.dataset.label;
      }
    }

    // Stepper +/- — apenas ajusta o campo "quantity"; o submit do form
    // adiciona ao carrinho e redireciona para /cart (comportamento nativo).
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.riza-qty__btn');
      if (!btn) return;
      const input = btn.parentElement.querySelector('.riza-qty__input');
      if (!input) return;
      input.value = (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.step, 10);
      clamp(input);
    });

    // Sanitiza valor digitado (não deixa abaixo do mínimo nem acima do estoque)
    document.addEventListener('change', (e) => {
      const input = e.target.closest('.riza-qty__input');
      if (input) clamp(input);
    });

    // Camada extra: bloqueia o submit se a quantidade ultrapassar o restante
    document.addEventListener('submit', (e) => {
      const form = e.target.closest('.riza-pcard__form');
      if (!form) return;
      const input = form.querySelector('.riza-qty__input');
      if (!input) return;
      const max = maxFor(input);
      if (max !== null && (parseInt(input.value, 10) || 1) > max) {
        e.preventDefault();
        clamp(input);
      }
    });

    // Desconta a quantidade já presente no carrinho do estoque disponível
    function applyCartLimits() {
      fetch(root_url + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then((r) => r.json())
        .then((cart) => {
          const inCart = {};
          (cart.items || []).forEach((it) => {
            inCart[it.variant_id] = (inCart[it.variant_id] || 0) + it.quantity;
          });
          document.querySelectorAll('.riza-qty__input[data-max]').forEach((input) => {
            const stock = parseInt(input.dataset.max, 10);
            const vid = parseInt(input.dataset.variant, 10);
            input.dataset.remaining = Math.max(0, stock - (inCart[vid] || 0));
            clamp(input);
          });
        })
        .catch(() => {});
    }

    // Estado inicial (ex.: estoque = 1 desabilita o "+") + ajuste pelo carrinho
    document.querySelectorAll('.riza-qty__input').forEach(clamp);
    applyCartLimits();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["riza-rmini"] && !Shopify.designMode) return;
  try {
    (function () {
    function clamp(input) {
      const min = parseInt(input.min, 10) || 1;
      const max = input.dataset.max ? parseInt(input.dataset.max, 10) : null;
      let val = parseInt(input.value, 10) || min;
      if (max !== null && val > max) val = max;
      if (val < min) val = min;
      input.value = val;
      const wrap = input.parentElement;
      const minus = wrap.querySelector('.riza-rmini__qty-btn[data-step="-1"]');
      const plus = wrap.querySelector('.riza-rmini__qty-btn[data-step="1"]');
      if (minus) minus.disabled = val <= min;
      if (plus) plus.disabled = max !== null && val >= max;
    }

    // Stepper +/- (o submit do form nativo adiciona ao carrinho e vai para /cart)
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.riza-rmini__qty-btn');
      if (!btn) return;
      const input = btn.parentElement.querySelector('.riza-rmini__qty-input');
      if (!input) return;
      input.value = (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.step, 10);
      clamp(input);
    });

    document.addEventListener('change', (e) => {
      const input = e.target.closest('.riza-rmini__qty-input');
      if (input) clamp(input);
    });

    // Bloqueia o submit se passar do estoque
    document.addEventListener('submit', (e) => {
      const form = e.target.closest('.riza-rmini__form');
      if (!form) return;
      const input = form.querySelector('.riza-rmini__qty-input');
      if (!input || !input.dataset.max) return;
      if ((parseInt(input.value, 10) || 1) > parseInt(input.dataset.max, 10)) {
        e.preventDefault();
        clamp(input);
      }
    });

    document.querySelectorAll('.riza-rmini__qty-input').forEach(clamp);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["riza-smooth-scroll"] && !Shopify.designMode) return;
  try {
    (function () {
    function headerOffset() {
      const h = document.querySelector('.header');
      return h ? h.getBoundingClientRect().height : 0;
    }
    function easeInOutCubic(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function scrollToEl(el) {
      const targetY = Math.max(0, el.getBoundingClientRect().top + window.pageYOffset - headerOffset() - 16);
      if (reduce) { window.scrollTo(0, targetY); return; }
      const startY = window.pageYOffset;
      const diff = targetY - startY;
      if (Math.abs(diff) < 2) return;
      const duration = 800;
      let start = null;
      function step(ts) {
        if (start === null) start = ts;
        const t = Math.min((ts - start) / duration, 1);
        window.scrollTo(0, startY + diff * easeInOutCubic(t));
        if (t < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    function elFromHash(hash) {
      if (!hash || hash === '#') return null;
      try { return document.getElementById(decodeURIComponent(hash.slice(1))); }
      catch (e) { return null; }
    }

    // Cliques em âncoras da mesma página → rola suave
    document.addEventListener('click', (e) => {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      const a = e.target.closest('a[href]');
      if (!a || a.target === '_blank') return;
      let url;
      try { url = new URL(a.href, window.location.href); } catch (err) { return; }
      if (url.origin !== window.location.origin) return;
      if (url.pathname !== window.location.pathname || !url.hash) return;
      const el = elFromHash(url.hash);
      if (!el) return;
      e.preventDefault();
      scrollToEl(el);
      if (history.pushState) history.pushState(null, '', url.hash);
    });

    // Carregou já com #hash (link vindo de outra página) → rola suave
    window.addEventListener('load', () => {
      const el = elFromHash(window.location.hash);
      if (el) setTimeout(() => scrollToEl(el), 60);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
